import Styles from './styles.module.scss';

export const Assignee = () => {
	return <span className={Styles.assignee}>N/A</span>;
};
